"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// components parser
var parser_1 = tslib_1.__importDefault(require("./axis/parser"));
var guide_line_1 = tslib_1.__importDefault(require("./guide-line"));
var parser_2 = tslib_1.__importDefault(require("./label/parser"));
// components state methods
var state_1 = tslib_1.__importDefault(require("./axis/state"));
var state_2 = tslib_1.__importDefault(require("./label/state"));
var state_3 = tslib_1.__importDefault(require("./tooltip/state"));
var COMPONENT_MAPPER = {
    axis: parser_1.default,
    label: parser_2.default,
    guideLine: guide_line_1.default,
};
var STATE_MAPPER = {
    tooltip: state_3.default,
    label: state_2.default,
    axis: state_1.default,
};
function getComponent(name, cfg) {
    var Components = COMPONENT_MAPPER[name];
    return new Components(cfg).config;
}
exports.getComponent = getComponent;
function getComponentStateMethod(name, type) {
    return STATE_MAPPER[name][type];
}
exports.getComponentStateMethod = getComponentStateMethod;
//# sourceMappingURL=factory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/components/factory.js
// module id = 61
// module chunks = 37